import RegistrationBewarePage from 'mutation/components/registration-beware';
import { Fragment } from 'react';

const ManagementBewarePage = (): React.ReactElement => {
  return (
    <Fragment>
      <RegistrationBewarePage title="Gestione Diffide" isBeware />
    </Fragment>
  );
};

ManagementBewarePage.displayName = 'Management Beware page component';

export default ManagementBewarePage;
